import { Link } from "react-router-dom";
import { WardenMark } from "../../brand/marks";
import { WARDEN, WARDEN_SERVICES } from "../../nav/navigation";

/**
 * Services menu, fronted by the Warden brand panel.
 *
 * Palo Alto puts an "Under Attack?" incident hotline in the panel CTA slot.
 * Odingard does not staff 24/7 incident response, so the equivalent slot is a
 * briefing request rather than an implied response capability.
 */
export function WardenMenu({ onNavigate }: { onNavigate: () => void }) {
  return (
    <div className="mm mm--brand">
      <div className="mm__brand">
        <Link to={WARDEN.href} className="mm__brand-lockup" onClick={onNavigate}>
          <WardenMark size={40} />
          <span>
            <b>WARDEN</b>
            <small>{WARDEN.byline}</small>
          </span>
        </Link>
        <h3>{WARDEN.heading}</h3>
        <p>{WARDEN.body}</p>
        <Link
          to={WARDEN.cta.href}
          className="mm__brand-cta"
          onClick={onNavigate}
        >
          {WARDEN.cta.label} →
        </Link>
      </div>

      <div className="mm__cols">
        {WARDEN_SERVICES.map((group) => (
          <div key={group.title} className="mm__col">
            <h4>{group.title}</h4>
            <ul>
              {group.links.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} onClick={onNavigate}>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
